export default __webpack_public_path__ + "static/media/Excellent Etherdew.fd516f20.jpg";